<template>
  <div v-if="eco" class="solid-table">
    <el-dialog
      v-drag:common
      :title="title[current]"
      :visible.sync="visible"
      width="800px"
    >
      <echart
        :option="option"
        :divStyle="{ height: '500px' }"
        :notMerge="true"
      ></echart>
    </el-dialog>
    <el-table
      :data="tableData"
      :span-method="spanMethod"
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }"
    >
      <el-table-column
        v-for="col in columns"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :type="col.type"
      >
        <template slot="header">
          <div
            v-if="!header[col.prop]"
            @click="clickColHeader(col.prop)"
            style="cursor: pointer;"
          >
            <i class="el-icon-s-data"></i>
            {{ col.label }}
          </div>
          <div v-else>
            {{ col.label }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import orderBy from 'lodash/orderBy';
import uniqBy from 'lodash/uniqBy';

const XKEY = {
  invest: 'totalInvestArr',
  output: 'energyDataArr',
  price: 'priceWithArr',
  rate: 'loanInterestRateArr'
};
export default {
  props: ['eco'],
  data() {
    return {
      visible: false,
      current: '',
      title: {
        PicfPbpAfter: '投资回收期(所得税后)(年)',
        PicfIrrBefore: '项目投资财务内部收益率(所得税前)(%)',
        PicfIrrAfter: '项目投资财务内部收益率(所得税后)(%)',
        CfopcIrr: '资本金财务内部收益率(%)',
        PicfNpvAfter: '项目投资财务净现值(所得税后)(万元)',
        Roi: '总投资收益率(ROI)(%)',
        ProfitTaxInvestmentRatio: '投资利税率(%)',
        Roe: '项目资本金净利润率(ROE)(%)',
        CfopcNpv: '资本金财务净现值(万元)'
      },
      header: {
        range: '变化幅度(%)',
        type: '方案类型'
      },
      type: {
        invest: '投资',
        output: '产量',
        price: '电价',
        rate: '利率'
      },
      tableData: [],
      option: null
    };
  },
  computed: {
    columns() {
      const cols = Object.keys(this.title).map(prop => ({
        label: this.title[prop],
        prop
      }));
      Object.keys(this.header).forEach(prop => {
        cols.unshift({
          label: this.header[prop],
          prop
        });
      });
      return cols;
    }
  },
  watch: {
    eco() {
      this.setTableData();
    }
  },
  mounted() {
    this.setTableData();
  },
  methods: {
    setTableData() {
      if (!this.eco) {
        this.tableData = [];
        return;
      }
      const rows = [];
      let maxCount = 0;
      let index = 0;
      Object.keys(this.type).forEach(type => {
        index += maxCount;
        maxCount = 0;
        Object.keys(this.title).forEach(key => {
          const values = this.eco[`${type}${key}`];
          if (values) {
            const valueArr = values.split(',');
            if (valueArr.length > maxCount) maxCount = valueArr.length;
            valueArr.forEach((val, i) => {
              if (!rows[index + i]) {
                const rangeArr = this.eco[XKEY[type]]
                  ? this.eco[XKEY[type]].split(',')
                  : [];
                rows[index + i] = {
                  type: this.type[type] + '变化分析',
                  range: rangeArr[i]
                };
              }
              rows[index + i][key] = val;
            });
          }
        });
        if (rows[index]) {
          rows[index].rowSpan = maxCount;
        }
      });
      //console.log('tableData', rows);
      this.tableData = rows;
    },
    clickColHeader(key) {
      if (Object.keys(this.header).includes(key)) return;
      this.current = key;
      this.setOption(key);
      this.visible = true;
    },
    setOption(key) {
      let text = this.title[key];
      let series = [];
      let xAxisData = [];
      if (this.eco) {
        series = Object.keys(this.type).map(typeKey => {
          const x = this.eco[XKEY[typeKey]];
          const y = this.eco[typeKey + key];
          let xArr = [];
          let yArr = [];
          if (x) {
            xArr = x.split(',');
            xAxisData = [...xAxisData, ...xArr];
          }
          if (y) {
            yArr = y.split(',');
          }
          const data = yArr.map((y, i) => [xArr[i] || 0, y]);
          return {
            name: this.type[typeKey],
            type: 'line',
            data
          };
        });
      }
      const legend = Object.keys(this.type).map(typeKey => this.type[typeKey]);
      //console.log('series', series, legend);
      let yAxisName = text[text.length - 2] || '';
      if (text[text.length - 3] === '万') {
        yAxisName = text[text.length - 3] + yAxisName;
      }
      this.option = {
        title: {
          text,
          left: 'center',
          textStyle: { color: '#fff' }
        },
        grid: {
          left: '3%',
          right: '15%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          name: '浮动比例（%）',
          // nameLocation: 'center',
          nameGap: 20,
          splitLine: { show: false },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          data: orderBy(uniqBy(xAxisData.map(v => Number(v))))
        },
        yAxis: {
          type: 'value',
          name: yAxisName,
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          }
        },
        backgroundColor: '#3b3a39',
        legend: {
          top: '30px',
          left: 'right',
          data: legend,
          textStyle: {
            color: '#fff'
          }
        },
        series
      };
    },
    spanMethod({ column, row }) {
      if (column.property !== 'type') return [1, 1];
      if (row.rowSpan) {
        return [row.rowSpan, 1];
      }
      return [0, 0];
    }
  }
};
</script>

<style lang="less" scoped>
// .solid-table{
//   /deep/.el-icon-s-data {
//     color: @brandColor;
//   }
// }
</style>
